

































































// @ts-ignore
import moment from 'moment';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly rules: any[];
  @Prop({ required: false }) readonly dense: boolean;
  @Prop({ required: false }) readonly dateLabel: string;
  @Prop({ required: false }) readonly timeLabel: string;

  @Model('input', { type: String })
  readonly value: string;

  dateTextInput: string;
  timeTextInput: string | null = null;

  dateShow: boolean = false;
  timeShow: boolean = false;

  get datePicker() {
    if (this.value) {
      return moment(this.value).format('YYYY-MM-DD');
    } else {
      return null;
    }
  }
  set datePicker(d: string | undefined | null) {
    if (!d) {
      this.$emit('input', null);
      return;
    }

    let time = '10:00';

    if (this.timePicker) {
      time = this.timePicker;
    }
    this.$emit(
      'input',
      moment(d + ' ' + time, 'YYYY-MM-DD HH:mm').toISOString(),
    );
  }

  get timePicker() {
    if (this.value) {
      return moment(this.value).format('HH:mm');
    } else {
      return null;
    }
  }
  set timePicker(t: string | undefined | null) {
    if (!this.datePicker) {
      this.$emit('input', null);
    } else {
      this.$emit(
        'input',
        moment(this.datePicker + ' ' + t, 'YYYY-MM-DD HH:mm').toISOString(),
      );
    }
  }

  checkDateInput() {
    if (!this.dateTextInput) {
      this.datePicker = null;
      return;
    }
    const m = moment(this.dateTextInput, 'DD/MM/YYYY');

    if (m.isValid()) {
      this.datePicker = m.format('YYYY-MM-DD');
    } else {
      this.dateTextInput = moment(this.value).format('DD/MM/YYYY');
    }
  }

  checkTimeInput() {
    if (!this.timeTextInput) {
      return;
    } else if (!this.datePicker && !this.timeTextInput) {
      this.timePicker = null;
      return;
    }
    const m = moment(this.timeTextInput, 'h:mm a');

    if (m.isValid()) {
      this.timePicker = m.format('HH:mm');
    } else {
      this.timeTextInput = moment(this.value).format('h:mm a');
    }
  }

  @Watch('value', { immediate: true })
  valueChanged() {
    if (this.value) {
      this.dateTextInput = moment(this.value).format('DD/MM/YYYY');
      this.timeTextInput = moment(this.value).format('h:mm a');
    } else {
      this.dateTextInput = '';
      this.timeTextInput = '';
    }
  }
}
